<template>
    <form class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            caption="瀏覽日曆事件"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="md minor-table">
                    <table>
                        <tbody>
                            <tr>
                                <th><label>事件名稱</label></th>
                                <td>{{ content.node.sub }}</td>
                            </tr>
                            <tr >
                                <th><label>開始時間</label></th>
                                <td>{{ timeFormatter(content.node.startTime) }}</td>
                            </tr>
                            <tr>
                                <th><label>結束時間</label></th>
                                <td>{{ timeFormatter(content.node.endTime) }}</td>
                            </tr>
                            <tr v-if="content.node.desc">
                                <th><label>敘述</label></th>
                                <td v-html="content.node.desc"></td>
                            </tr>
                            <tr v-if="content.node.cal">
                                <th><label>歸屬</label></th>
                                <td v-html="cal.sub"></td>
                            </tr>
                            <tr v-if="content.node.location">
                                <th><label>地點</label></th>
                                <td>{{ content.node.location }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        computed: {
            cal: function(){
                let $cal = this.content.extend.source.find(cal => { return cal.sn === this.content.node.cal});

                return $cal;
            },
            btns: function(){
                let $results = []

                let $edit = {
                        text: this.$t('site.func.edit'),
                        icon: 'create',
                        themes: 'major',
                        func: 'edit',
                    },
                    $remove = {
                        text: this.$t('popup.btn.remove'),
                        icon: 'delete',
                        themes: 'danger',
                        func: 'remove',
                    },
                    $cancel = {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }

                if( this.cal && this.cal.editable ) {
                    $results = [
                        $edit,
                        $remove,
                    ]
                }

                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            timeFormatter: function(obj){
                let _noon = '上午';

                let _year = obj.year,
                    _month = obj.month,
                    _date = obj.date,
                    _hour = obj.hour,
                    _minutes = obj.minutes;

                if( _hour === 12 ){
                    _noon = '下午';
                }else if( _hour > 12 ){
                    _hour -= 12;
                    _noon = '下午';
                }

                _minutes = this.$okaTool.doubleCount(_minutes);

                return _year +'/'+ _month +'/'+ _date +' '+ _noon + _hour +':'+ _minutes +':00'
            },
            edit: function(){
                this.content.extend.editEvent(this.content.node);
            },
            remove: function(){
                this.content.extend.removeEvent({
                    sn: this.content.node.sn
                }, true);

                this.close();
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
